import moment from "moment";

export function formatCreatedDateForDisplay(date: Date, type: "Created" | "Updated") {
  return moment(date).utc().format(`[${type}] MMM DD, YYYY [at] H:mm [UTC]`);
}
